import axios from "axios";
import React, { useEffect, useState, useMemo, memo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { putApi } from "../../api/getUser";
import RowOptions from "../../shared/components/table/components/RowOptions";
import VehicleComponent from "../../shared/components/table/components/VehicleComponent";
import {
  AddFormButton,
  ColumnHeading,
} from "../../shared/components/TableElements";
import DataReactTable from "../DataTable/components/DataReactTable";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { NATEXT } from "../../shared/constants";
import { useAuth } from "../../contexts/AuthContext";
import { fetchExpenseTasks } from "../../features/expenseTasks/expenseTasksSlice";
import { useDispatch } from "react-redux";
import { updateNoOfRecords } from "../../features/columns/columnsSlice";
import { sortItems } from "../../shared/helpers";
import { useLocation } from "react-router";

// Separate component for vehicle cell to properly use hooks
const VehicleCell = memo(({ row, allVehicles }) => {
  const [currentVehicle, setCurrentVehicle] = useState(null);

  useEffect(() => {
    if (allVehicles?.length > 0) {
      if (row.original.veh_id !== "All") {
        let current = allVehicles.find((v) => v.veh_id === row.original.veh_id);
        setCurrentVehicle(current);
      } else {
        setCurrentVehicle(null);
      }
    }
  }, [allVehicles, row]);

  return (
    <VehicleComponent
      vehicleName={currentVehicle ? currentVehicle?.label : "All"}
      vehicleId={currentVehicle ? currentVehicle?.veh_id : ""}
      vehicleImg={currentVehicle ? currentVehicle?.veh_img : ""}
      orgId={row.original.org_id}
    />
  );
});

const ExpensesTasksTable = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const location = useLocation();
  const fromCancel = location.state?.fromCancel;

  const {
    reload,
    setReload,
    setLoading,
    isClientApiCalled,
    setIsClientApiCalled,
    isLoggedIn,
    isViewOnly,
  } = useAuth();

  const allExpenseTasks = useSelector((state) => state.expenseTasks.list);
  const allVehicles = useSelector((state) => state.vehicles.list);

  //Effect to set initial default rows
  useEffect(() => {
    if (isLoggedIn && (!isClientApiCalled || !fromCancel)) {
      (async () => {
        setIsClientApiCalled(true);
        setLoading(true);
        const apiData = {
          querystring: "get_user_screen_settings",
          screen_name: "expensetasks",
        };
        const userSettingsRes = await putApi(apiData, "dashboard");
        if (userSettingsRes.success) {
          const { data } = userSettingsRes;
          const { default_rows } = data;
          dispatch(updateNoOfRecords({ defaultRows: default_rows }));
          setLoading(false);
        }
      })();
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (reload === "expensetasks") {
      (async () => {
        //Fetch all expense tasks
        const apiData = {
          querystring: "getallexpensetask",
          expense_veh_id: "All",
        };
        dispatch(fetchExpenseTasks(apiData));

        setReload("");
      })();
    }
  }, [reload]);

  const columnHeaders = useMemo(
    () => [
      {
        id: 1,
        Header: t("asset"),
        accessor: "veh_id",
        //disableGlobalFilter: true,
        Cell: ({ row }) => <VehicleCell row={row} allVehicles={allVehicles} />,
      },
      {
        id: 2,
        Header: t("expense_task"),
        accessor: "expense_task_name",
        accessorID: "task_name",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, "expense_task_name");
        },
      },
      // {
      //   id: 3,
      //   Header: t("last_expense_date"),
      //   accessor: "last_updated_at",
      //   Cell: ({ row }) =>
      //     row?.original?.service_date
      //       ? new Date(row?.original?.expense_date * 1000).toLocaleDateString(
      //           "en-GB"
      //         )
      //       : NATEXT,
      //   //disableGlobalFilter: true,
      // },
      {
        id: "edit",
        Header: "",
        accessor: "edit",
        accessorId: "edit",
        Cell: ({ row }) => <RowOptions rowData={row?.original} />,
        disableSortBy: true,
      },
    ],
    [t, allVehicles]
  );

  const reactTableData = {
    tableHeaderData: columnHeaders,
    tableRowsData: allExpenseTasks,
  };
  return (
    <Container>
      <Row className="mx-1 d-flex align-items-center justify-content-around">
        <Col
          sm={10}
          //className="d-flex justify-content-start align-items-center"
        >
          <ColumnHeading>{t("expense_tasks")}</ColumnHeading>
        </Col>
        <Col sm={2} className="d-flex justify-content-end align-items-center">
          {/* {roleId !== 4 && ( */}
          {!isViewOnly && (
            <Link to={"/expenses/expensetasks/addnew"}>
              <AddFormButton>{t("add_expense_task")}</AddFormButton>
            </Link>
          )}
          {/* )} */}
        </Col>
      </Row>
      <Row>
        <DataReactTable
          reactTableData={reactTableData}
          //valuesArray={servicesValuesArray}
          //initialData={initialData}
          //filterToggleColumns={filterToggleColumns}
          //defaultColumns={defaultColumns}
          //columnSizeData={columnSizeData}
        />
      </Row>
    </Container>
  );
};

export default ExpensesTasksTable;
